import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeCardModule } from 'se-fe-card'
import { SeHouseholdSetupFeatureChildContactInfoModule } from '../lib/se-household-setup-feature-child-contact-info.module'
import { ChildContactInfoDocsComponent } from './child-contact-info-docs/child-contact-info-docs.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [ChildContactInfoDocsComponent],
  exports: [ChildContactInfoDocsComponent],
  imports: [
    CommonModule,
    SeFeAlertModule,
    SeFeCardModule,
    SeHouseholdSetupFeatureChildContactInfoModule
  ],
  providers: PROVIDERS
})
export class SeHouseholdSetupFeatureChildContactInfoDocsModule { }
